export default __webpack_public_path__ + "static/textured-circle-6c9f71431aae41e0c84bdf856f592097.svg";